export default "__VITE_ASSET__d8439f1e__"